/*
* @Author: abhishek714
* @Date:   2024-10-07 16:48:39
* @Last Modified by:   babysoft08
* @Last Modified time: 2024-12-28 14:20:35
*/
import React from 'react';
import moment from 'moment';
import { Link, Redirect } from 'react-router-dom';
import uploadImageIcon from '../../images/assets/image-plus.webp';
import $ from 'jquery';
import UserService from './../../services/UserService/UserService';
import loading_icon from '../../images/loading.gif';
import ascIcon from '../../images/sorting-asc.png';
import descIcon from '../../images/sorting-desc.png';
import defaultIcon from '../../images/sorting-default.png';

class OrderHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fields: {},
			errors: {},
			success_redirect: 0,
			order_history: [],
			filtered_order_history: [],
			showLoader: 1,
			searchQuery: '',
			sortOrder: 'desc',
			sortField: 'date_entered',
			tableHeaders: [
				{ label: 'Date', sorting_icon: descIcon, field: 'date_entered', is_sortable: true },
				{ label: 'Purchase Order #', sorting_icon: defaultIcon, field: 'customer_po', is_sortable: false },
				{ label: 'Sales Order #', sorting_icon: defaultIcon, field: 'so_number', is_sortable: false },
				{ label: 'Part #', sorting_icon: defaultIcon, field: 'model', is_sortable: false },
				{ label: 'Description', sorting_icon: defaultIcon, field: 'description', is_sortable: false },
				{ label: 'Qty', sorting_icon: defaultIcon, field: 'qty_ordered', is_sortable: false },
				{ label: 'Unit Price', sorting_icon: defaultIcon, field: 'price', is_sortable: false },
				{ label: 'Total Price', sorting_icon: defaultIcon, field: 'total_price', is_sortable: false },
			]
		};
		this.userService = new UserService();
		this.filterOrders = this.filterOrders.bind(this);
		this.handleClearInput = this.handleClearInput.bind(this);
		this.handleSearchInput = this.handleSearchInput.bind(this);
		this.handleSorting = this.handleSorting.bind(this);
	}

	componentDidMount() {
		if (
			localStorage.getItem('techtop_user_id') != '' &&
			localStorage.getItem('techtop_user_id') != null
		) {
			this.setState({ user_id: localStorage.getItem('techtop_user_id') });
			this.setState({
				first_name: localStorage.getItem('techtop_user_first_name'),
			});
			this.setState({
				last_name: localStorage.getItem('techtop_user_last_name'),
			});
			this.setState({
				company: localStorage.getItem('techtop_user_company'),
			});
			this.setState({ company_logo: localStorage.getItem('techtop_user_company_logo') });
			this.setState({ phone: localStorage.getItem('techtop_user_phone') });
			this.setState({ cell_phone: localStorage.getItem('techtop_user_cell_phone') });
			this.setState({ direct_phone: localStorage.getItem('techtop_user_direct_phone') });
			this.setState({ fax: localStorage.getItem('techtop_user_fax') });
			this.setState({ address: localStorage.getItem('techtop_user_address') });
			this.setState({ state: localStorage.getItem('techtop_user_state') });
			this.setState({ city: localStorage.getItem('techtop_user_city') });
			this.setState({ zip: localStorage.getItem('techtop_user_zip') });
			this.setState({ is_login: 1 });
			this.getOrderHistory(localStorage.getItem('techtop_user_company'));
		}
	}

	getOrderHistory(company = null) {
		company = (company === null) ? this.state.company : company;
		const status = 'Fulfilled,Closed Short';
		this.setState({ showLoader: 1 });
		this.userService.getOrderHistory({ company: company, order_by: 'date_desc', status: status }).then(response => {
			if (response && response.status === 200) {
				if (response.data.response === 'fail' || !response.data.result?.order_history) {
					this.setState({ order_history: [], filtered_order_history: [], showLoader: 0 });
				} else {
					const data = Array.isArray(response.data.result.order_history) ? response.data.result.order_history : [];
					this.setState({ order_history: data }, () => {
						this.filterOrders(this.state.searchQuery, this.state.sortField, this.state.sortOrder);
					});
				}
			} else {
				this.setState({ showLoader: 0 });
			}
		}).catch(() => {
			this.setState({ showLoader: 0 });
		});
	}

	handleSearchInput = (event) => {
		const searchQuery = event.target.value;
		this.setState({ searchQuery: searchQuery }, () => {
			this.filterOrders(searchQuery, this.state.sortField, this.state.sortOrder);
		});
	};

	handleClearInput = (event) => {
		const searchQuery = event.target.value;
		this.setState({ searchQuery: searchQuery }, () => {
			this.filterOrders(searchQuery, this.state.sortField, this.state.sortOrder);
		});
	};

	sortList(list, field, order = 'asc') {
		const getValue = (obj, path) => {
			if (!obj) return '';
			return path.split('.').reduce((acc, key) => acc?.[key], obj) ?? '';
		};

		return [...list].sort((a, b) => {
			const valA = getValue(a, field);
			const valB = getValue(b, field);

			if (field === 'date_entered') {
				const timeA = valA ? moment(valA).valueOf() : 0;
				const timeB = valB ? moment(valB).valueOf() : 0;
				return order === 'asc' ? timeA - timeB : timeB - timeA;
			}

			const cleanNumA = String(valA ?? '').replace(/[^0-9.-]+/g, '');
			const cleanNumB = String(valB ?? '').replace(/[^0-9.-]+/g, '');
			const numA = parseFloat(cleanNumA);
			const numB = parseFloat(cleanNumB);

			const isNumericField = ['qty_ordered', 'price', 'total_price'].includes(field) ||
				(!isNaN(numA) && !isNaN(numB) && cleanNumA !== '' && cleanNumB !== '');

			if (isNumericField && !isNaN(numA) && !isNaN(numB)) {
				return order === 'asc' ? numA - numB : numB - numA;
			}

			const strA = String(valA ?? '').trim();
			const strB = String(valB ?? '').trim();
			return order === 'asc'
				? strA.localeCompare(strB, undefined, { numeric: true, sensitivity: 'base' })
				: strB.localeCompare(strA, undefined, { numeric: true, sensitivity: 'base' });
		});
	}

	filterOrders(searchQuery = this.state.searchQuery, sortField = this.state.sortField, sortOrder = this.state.sortOrder) {
		const { order_history } = this.state;
		if (!Array.isArray(order_history)) {
			this.setState({ filtered_order_history: [], showLoader: 0 });
			return;
		}

		let filtered = [...order_history];
		const query = (searchQuery || '').trim().toLowerCase();

		if (query) {
			filtered = filtered.filter((order) => {
				const purchaseOrder = String(order.customer_po || '').toLowerCase();
				const salesOrder = String(order.so_number || '').toLowerCase();
				const partNumber = String(order.model || '').toLowerCase();

				return (
					purchaseOrder.includes(query) ||
					salesOrder.includes(query) ||
					partNumber.includes(query)
				);
			});
		}

		if (sortField) {
			filtered = this.sortList(filtered, sortField, sortOrder);
		}

		this.setState({ filtered_order_history: filtered, showLoader: 0 });
	}

	handleSorting(field) {
		const { sortField, sortOrder, tableHeaders } = this.state;
		let order = 'asc';
		if (sortField === field) {
			order = sortOrder === 'asc' ? 'desc' : 'asc';
		} else if (field === 'date_entered') {
			order = 'desc';
		}

		// Update sorting icons
		const updatedHeaders = tableHeaders.map(header => {
			if (header.field === field) {
				return { ...header, sorting_icon: order === 'asc' ? ascIcon : descIcon };
			} else {
				return { ...header, sorting_icon: defaultIcon };
			}
		});

		this.setState({
			tableHeaders: updatedHeaders,
			sortField: field,
			sortOrder: order
		}, () => {
			this.filterOrders(this.state.searchQuery, field, order);
		});
	}

	renderOrderHistory() {
		let { filtered_order_history, showLoader } = this.state;
		if (showLoader) {
			return (
				<React.Fragment>
					<tr>
						<td colSpan="8" style={{ textAlign: 'center' }}>
							<img src={loading_icon} alt="Loading..." />
						</td>
					</tr>
				</React.Fragment>
			);
		} else {
			if (!Array.isArray(filtered_order_history) || filtered_order_history.length === 0) {
				return (
					<React.Fragment>
						<tr>
							<td colSpan="8" style={{ textAlign: 'center' }}>
								No data found.
							</td>
						</tr>
					</React.Fragment>
				);
			} else {
				return (
					<React.Fragment>
						{filtered_order_history.map((order, index) => (
							<tr key={index}>
								<td>{order.date_entered ? moment(order.date_entered).format('MM/DD/YYYY') : ''}</td>
								<td>{order.customer_po}</td>
								<td>{order.so_number}</td>
								<td>{order.motor ? (<a href={`/motors/${order.model}`} target="_blank" rel="noopener noreferrer">
									{order.model}
								</a>) : order.model}</td>
								<td>{order.description}</td>
								<td>{order.qty_ordered}</td>
								<td>${order.price}</td>
								<td>${order.total_price}</td>
							</tr>
						))}
					</React.Fragment>
				);
			}
		}
	}

	render() {
		let { tableHeaders } = this.state;

		return (
			<React.Fragment>
				<div className="middle-div">
					<section className="order-history-section">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="default-title">
										<div className="row">
											<div className="col-md-6">
												<h1 className="m-0 color1">Order History</h1>
											</div>
											<div className="col-md-6">
												<h2 className="m-0 color1 text-end">{this.state.company}</h2>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<div className="common-width-div">
										<div className="row">
											<div className="col-md-12">
												<div className="input-group search-div">
													<input type="search" className="form-control rounded" placeholder="Search..." value={this.state.searchQuery} onChange={this.handleSearchInput} onInput={this.handleClearInput} />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<div className="table-responsive mt-3 order-history-table">
													<table className="table">
														<thead>
															<tr>
																{tableHeaders.map((header, index) => (
																	<th
																		key={index}
																		style={header.is_sortable ? { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' } : {}}
																		onClick={header.is_sortable ? () => this.handleSorting(header.field) : undefined}
																	>
																		{header.label} {header.is_sortable && (
																			<img
																				src={header.sorting_icon}
																				alt="sorting_icon"
																				className="sorting-icon"
																				style={{ cursor: 'pointer', marginLeft: '5px', verticalAlign: 'middle' }}
																			/>
																		)}
																	</th>
																))}
															</tr>
														</thead>
														<tbody>
															{this.renderOrderHistory()}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</React.Fragment>
		);
	}
}

export default OrderHistory;